export function overrideStyles(selector, style, delay) {
    if (delay === void 0) { delay = null; }
    var elements = Array.from(document.querySelectorAll(selector));
    elements.forEach(function (el) {
        if (delay) {
            Object.assign(el.style, style);
        }
        else {
            window.setTimeout(function () { return Object.assign(el.style, style); }, delay);
        }
    });
}
export function copyTextToClipBoard(text) {
    var textHolder = document.createElement('textarea');
    textHolder.value = text;
    textHolder.setAttribute('readonly', '');
    textHolder.style.position = 'absolute';
    textHolder.style.left = '-9999px';
    document.body.appendChild(textHolder);
    textHolder.select();
    document.execCommand('copy');
    document.body.removeChild(textHolder);
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/dom.ts
// module id = 172
// module chunks = 0